import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propChildren, propStr, } from '../../../../../../../helpers/custom-prop-types';
/**
 * セミナー入力フォームのラベル用コンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormFieldAnyLabel = (props) => {
    const { className, text } = props;
    return (_jsx("div", Object.assign({ className: clsx('professional_seminar_one_form_field_any_label', className) }, { children: _jsx("div", Object.assign({ className: 'label_text' }, { children: text })) })));
};
SeminarOneFormFieldAnyLabel.propTypes = {
    className: propStr(),
    text: propChildren(),
};
SeminarOneFormFieldAnyLabel.defaultProps = {
    className: '',
    text: '任意',
};
export default SeminarOneFormFieldAnyLabel;
